import {api} from '../../../shared';
import {DonationsFilter, DonationWithMetaModel} from '../model';

export const donationsApi = {
  getDonationsByAppeal: async (appealId: string, params: DonationsFilter = {}): Promise<DonationWithMetaModel> => {
    const {data} = await api.get<DonationWithMetaModel>(`/api/finance/public/appeals/${appealId}/donations`, {params});
    return data;
  },
};
